angular.module('app').controller('LandingCtrl',
    ['$scope', 'LoginFactory', 'TransitionManager', 'LogOffService', 'LocalStorageRepository',
        function ($scope, LoginFactory, TransitionManager, LogOffService, LocalStorageRepository) {
            'use strict';

            $scope.currentUserID = LocalStorageRepository.getUserID();

            $scope.logoff = function () {
                LogOffService.logoff().then(function () {
                    TransitionManager.transition({appRoute: 'login'});
                });
            };
        }]
);
